'use client';

import { useEffect, useState } from 'react';

/**
 * Whether a fixed navbar should be showing: hidden once the page is scrolled
 * down past `threshold`, revealed again on any upward scroll.
 */
export const useVisibleOnScroll = (threshold = 100) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Held in the closure rather than in state: the listener only compares
    // against it, so storing it in state would re-subscribe on every frame of
    // a scroll for a value that is never rendered.
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setVisible(!(currentScrollY > lastScrollY && currentScrollY > threshold));
      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return visible;
};
